import { render, staticRenderFns } from "./PasswordTab.vue?vue&type=template&id=376a38f2"
import script from "./PasswordTab.vue?vue&type=script&lang=ts"
export * from "./PasswordTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports